<template>
  <div>
    <v-icon v-for="(a, key) in rate" :key="a">star</v-icon>
    <!-- <v-icon v-for="(i, key) in (max - rate)" :key="i">star_border</v-icon> -->
    <v-icon v-for="(i, key) in (max - rate)" :key="`${i}-${max}`">star_border</v-icon>
  </div>
</template>

<script>
export default {

  name: 'wz-rating',

  props: {
    max: {
      type: Number,
      required: true
    },
    rate: {
      type: Number,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzRating.vue